import script from "./BoletoAsignado.vue?vue&type=script&setup=true&lang=js"
export * from "./BoletoAsignado.vue?vue&type=script&setup=true&lang=js"

import "./BoletoAsignado.vue?vue&type=style&index=0&id=36c2843f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c2843f"]])

export default __exports__